export const addParams = (endpoint: string, params?: { [key: string]: any }): string => {
  if (!params) {
    return endpoint;
  }

  // convert dates to ISO strings
  Object.keys(params).forEach((key) => {
    if (params[key] && typeof params[key].toISOString === 'function') {
      params[key] = params[key].toISOString();
    }
  });

  // get the key names for all fields that hold arrays
  const arrayKeys = Object.keys(params).filter((key) => Array.isArray(params[key]));

  // get the params without array-type fields
  const nonArrayParams = reduceObjectArrayToObject(
    Object.keys(params).map((key) =>
      arrayKeys.includes(key) || params[key] === undefined ? {} : { [key]: params[key] }
    )
  );

  // manually stringify the array-type params
  const arrayParamsAsString = arrayKeys
    .map((key) => (params[key] as any[]).map((value) => `${key}=${value}`).join('&'))
    .join('&');

  const paramsAsString = filterAndJoin([new URLSearchParams(nonArrayParams).toString(), arrayParamsAsString], '&');

  return filterAndJoin([endpoint, paramsAsString], '?');
};

/**
 * Filter falsy elements from an array, then join them. Default separator: `', '`.
 */
export const filterAndJoin = (parts: (string | false | null | undefined)[], separator: string = ', ') =>
  parts.filter(Boolean).join(separator);

/**
 * Reduce an array of objects to an object.
 *
 * @example
 * reduceObjectArrayToObject([{ a: 'foo' }, { b: 'bar' }])
 * // => { a: 'foo', b: 'bar' }
 */
export const reduceObjectArrayToObject = (array: { [key: string]: any }[]) =>
  array.reduce((acc, val) => Object.assign(Object.assign({}, acc), val), {});
